import {needAuth, noAuh} from "../instance/Instance";
import {AxiosError} from "axios";
import {getParam} from "../../components/Utils/Utils";
import {encodeQueryData, getUrl} from "../../components/commonmethod/CommonMethod";
import {apiRequest} from "../../components/Utils/SimmsUtils";

async function getUserDrawerList() {
    try{
        return  await needAuth.get('/users/drawer');
    }catch (error){
        return error;
    }
}

async function getUserListWithNoPages(search) {
    try{
        return  await needAuth.post('/users/nps', search);
    }catch (error){
        return error;
    }
}

async function getUserList(search, pageable) {
    console.log(">> 사용자 List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {

            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post('/users/list?'+pageStr,search);
    }catch (error){
        return error;
    }
}

const selectUserAccounts = async (searchDto, pageable) => {
    try {
        return await needAuth.post(`/users?${getParam(pageable)}`, searchDto);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

async function getUser(userId) {
    console.log(">>> api : 단일 user 조회 id: "+userId)
    try{
        return await needAuth.get('/users/'+userId);
    }catch (error){
        return error;
    }
}

async function getUsers(search, pageable) {
    console.log(">>> api : user 목록 조회")
    try{
        const usr = getUrl('users?', search, pageable)
        return  await needAuth.get(usr);
    }catch (error){
        return error;
    }
}



async function createUser(user, images) {
    console.log(">>> api : user 등록")
    const formData = new FormData();

    images.forEach((image, index) => {
        formData.append(`images`, image);
    });

    formData.append(
        "userAccountRequestDto",
        new Blob([JSON.stringify(user)], { type: "application/json" })
    );
    try{
        return  await needAuth.post(
            '/users/create',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        );
    }catch (error){
        return error;
    }
}

async function updateUser(user, images = []) {
    console.log(">>> api : user 수정")
    // 안에 있는 객체의 아이디만 추출해서 다시 객체로 만들어준다.
    const updateData = (prev) => {
        return {
            ...prev,
            company: prev.company ? {id : prev.company.id} : null,
            department: prev.department ? {id : prev.department.id} : null,
            pmInCharge: prev.pmInCharge ? {id : prev.pmInCharge.id} : null,
            proxy: prev.proxy ? {id : prev.proxy.id} : null,
            userGroup: prev.userGroup ? {id : prev.userGroup.id} : null,
        }
    }
    const updateUser = updateData(user);
    const formData = new FormData();

    images.forEach((image) => {
        formData.append("images", image);
    });

    formData.append(
        "userAccountUpdateRequestDto",
        new Blob([JSON.stringify(updateUser)], { type: "application/json" })
    );
    try{
        return  await needAuth.put(
            '/users/' + user.id,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        );
    }catch (error){
        return error;
    }
}

async function disablesUsers(checked) {
    console.log(">>> api : users 비활성화")
    try{
        return  await needAuth.put(
            '/users/disables',
            checked
        );
    }catch (error){
        return error;
    }
}

async function enablesUsers(checked) {
    console.log(">>> api : users 활성화")
    try{
        return  await needAuth.put(
            '/users/enables',
            checked
        );
    }catch (error){
        return error;
    }
}

async function usernameIsDuplicate(username) {
    console.log(">>> api : username 중복 확인")
    let postParam = {username : username}
    try{
        return  await needAuth.post(
            '/users/usernameIsDuplicate'
            ,postParam
        );
    }catch (error){
        return error;
    }
}

async function nameIsDuplicate(name) {
    console.log(">>> api : name 중복 확인")
    let postParam = {name : name}
    try{
        return  await needAuth.post(
            '/users/nameIsDuplicate'
            ,postParam
        );
    }catch (error){
        return error;
    }

}

async function checkIsSImmsADmin(id, pw) {
    return await noAuh.get(`/key?id=${id}&pw=${pw}`)
}


async function requestLicenseKey(expire, assetCount, userCount, platform) {
    return await noAuh.get(`/key/get?expire=${expire}&assetCount=${assetCount}&userCount=${userCount}&platform=${platform}`)
}

export async function requestSecondVersionLicenseKey(prevLicenseKey, prevLicenseStart, prevLicenseEnd, prevLicenseAssetCount, prevLicenseUserCount) {
    return await noAuh.get(`/key/get/prev?prevLicenseKey=${prevLicenseKey}&prevLicenseStart=${prevLicenseStart}&prevLicenseEnd=${prevLicenseEnd}&prevLicenseAssetCount=${prevLicenseAssetCount}&prevLicenseUserCount=${prevLicenseUserCount}`)
}

const getUserAccountsByUserGroup = async (userGroupId, success) => {
    return apiRequest(() => needAuth.get(`/users/userGroups/${userGroupId}`), success)
}

async function getUserRoles() {
    return await needAuth.get(`/users/getRoles`);
}

async function getUserAssetCount(id) {
    return await needAuth.get(`/users/get-count/${id}`);
}

async function updateUserAccount(data) {
    try {
        return await needAuth.put(`/users/single`, data);
    } catch (error) {
        return error;
    }
}

const updateUserGroup = async (data, success) => {
    return apiRequest(() => needAuth.put(`/users/userGroup`, data), success);
}

export async function getIndividualSetting(){
    try {
        return await needAuth.get(`/users/setting`);
    } catch (error) {
        return error;
    }
}
export async function setIndividualSetting(v){
    try {
        return await needAuth.post(`/users/setting/headers`, v);
    } catch (error) {
        return error;
    }
}
export async function saveIndividualSetting(target, v){
    try {
        return await needAuth.post(`/users/setting/${target}`, v);
    } catch (error) {
        return error;
    }
}
export async function resetIndividualSetting(target, type){
    try {
        return await needAuth.put(`/users/reset/${target}/${type}`);
    } catch (error) {
        return error;
    }
}

export async function adminLogin(id){
    return await needAuth.get(`/user/adminLogin/${id}`);
}

export {
    selectUserAccounts,
    getUser,
    getUsers,
    createUser,
    updateUser,
    disablesUsers,
    enablesUsers,
    usernameIsDuplicate,
    nameIsDuplicate,
    checkIsSImmsADmin,
    requestLicenseKey,
    getUserAccountsByUserGroup,
    getUserList,
    getUserRoles,
    getUserAssetCount,
    getUserDrawerList,
    updateUserAccount,
    updateUserGroup,
    getUserListWithNoPages
};